import { Injectable } from '@angular/core';

import { MemoryMapCacheRepository } from './memory-map-cache.repository';

@Injectable()
export class TaxClassificationsCacheRepository extends MemoryMapCacheRepository<string[]> {
    getKey(id: string): string {
        return 'TaxClassificationsCacheRepository' + String(id);
    }
}
